/**
 * Generate a SHA-256 hash from a string.
 * Works in both browser (Web Crypto API).
 *
 * @param str - The input string to hash
 * @returns Promise<string> - The hex-encoded SHA-256 hash
 */
export async function hashString(str: string): Promise<string> {
  // Browser environment
    const encoder = new TextEncoder();
    const data = encoder.encode(str);
    const hashBuffer = await window.crypto.subtle.digest("SHA-256", data);
    return bufferToHex(hashBuffer);
}
/**
 * Convert ArrayBuffer to hex string.
 *
 * @param buffer - The ArrayBuffer to convert
 * @returns string - Hex-encoded representation
 */
function bufferToHex(buffer: ArrayBuffer): string {
  const view = new Uint8Array(buffer);
  let hex = "";
  for (let i = 0; i < view.length; i++) {
    const b = view[i].toString(16);
    hex += b.length === 1 ? "0" + b : b;
  }
  return hex;
}
